const panelExpandWidth = 200
const panelCollapseWidth = 75

export default {
  startingWrapper: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  startingContent: {
    width: 300,
  },
  indicatorWrapper: {
    position: 'relative',
    height: 100,
  },
  panelLeftCollapse: {
    width: panelCollapseWidth,
  },
  panelLeftExpand: {
    width: panelExpandWidth,
  },
  wrapper: {
    textAlign: 'center',
  },
  content: {
    paddingLeft: panelExpandWidth + 20,
  }
}


// WEBPACK FOOTER //
// ./src/components/App/AppStyle.js